export default "__VITE_ASSET__CghTsX35__"